<template>
  <div>
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <div class="title">
              <p>{{ pageData.length }} Batches</p>
            </div>
          </template>
          <template slot="content">
            <el-table
              :data="pageData"
              v-loading="loading"
              :empty-text="'No batches'"
            >
              <el-table-column prop="code">
                <template slot="header">
                  <span class="ra-table--header">
                    Code
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="created_at">
                <template slot="header">
                  <span class="ra-table--header">
                    Created on
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatShortDate(scope.row.created_at, "d-m-y") }} -
                    {{ mFormatTime(scope.row.created_at) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="modified_at">
                <template slot="header">
                  <span class="ra-table--header">
                    Updated on
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatShortDate(scope.row.modified_at, "d-m-y") }} -
                    {{ mFormatTime(scope.row.modified_at) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column width="100">
                <template slot-scope="scope">
                  <p
                    class="text-cursor text-primary text-underline"
                    @click="setBatch(scope.row.id, scope.row.code)"
                  >
                    View items
                  </p>
                </template>
              </el-table-column>
            </el-table>
            <ra-pagination
              v-if="dataFound"
              :from="from"
              :to="to"
              :total="total"
              :pageSize="pagination.perPage"
              :current-page.sync="currentPage"
            />
          </template>
        </ra-card>
      </el-col>
    </el-row>
    <user-importation-batch
      :show.sync="batch.visibility"
      :batch="batch"
      :app-code="appCode"
    />
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import UserImportationBatch from "@/components/Products/AuthX/Applications/Users/UserImportationBatch";
const paging = {
  perPage: 50,
  currentPage: 1,
  total: 0
};

export default {
  name: "UsersImportation",
  props: {
    appName: {
      type: String,
      default: ""
    },
    appCode: {
      type: String,
      default: ""
    },
    imported: {
      type: Boolean,
      default: false
    }
  },
  components: { UserImportationBatch },
  data() {
    return {
      loading: true,
      form: {
        query: ""
      },
      pageData: [],
      currentPage: 1,
      pagination: { ...paging },
      batch: {
        visibility: false,
        id: null,
        code: null
      }
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    }
  },
  watch: {
    appCode() {
      this.getAppBatches();
    },
    imported() {
      if (this.imported) {
        this.getAppBatches();
      }
    }
  },

  created() {
    if (this.appCode) {
      this.getAppBatches();
    }
  },

  methods: {
    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    getAppBatches(customParams = "") {
      this.loading = true;
      const apiUrl = `apps/${this.appCode}/users/import/batches`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${customParams}&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },

    setBatch(id, code) {
      this.batch.id = id;
      this.batch.code = code;
      this.batch.visibility = true;
    },

    command(command) {
      const { action, code } = command;
      if (action === "user") {
        this.user.code = code;
        this.showAuthXUser = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  p {
    width: 100px;
  }
}
</style>
